import LazyLoad from "react-lazyload";

import dynamic from "next/dynamic";

import PropTypes from "prop-types";

import Img from "components/atoms/Img";
import LinkRouter from "components/atoms/LinkRouter";
import Title from "components/atoms/Title";
import Banner from "components/organisms/Banner";
import Faqs from "components/organisms/Faqs";
import HowItWorks from "components/organisms/HowItWorks";
import OnlineBankingTool from "components/organisms/OnlineBankingTool";
import OpenBankAccount from "components/organisms/OpenBankAccount";
import RequiredDocument from "components/organisms/RequiredDocument";
import Walkthrough from "components/organisms/Walkthrough";
import WhyChooseUs from "components/organisms/WhyChooseUs";
const NewsSlider = dynamic(() => import("components/organisms/NewsSlider"), {
  ssr: false,
});

const MerchantAccountConsultingTemplate = ({ data, dataJson }) => {
  const {
    country,

    breadcrumbs,
    dataHowToOpen,
    dataOpenBankFee,
  } = dataJson;

  return (
    <>
      <Banner
        minHeightBanner="banner-min-h-635"
        breadcrumbs={breadcrumbs}
        title={dataJson.title}
        description={dataJson.description}
        titleProps={{
          className: "banner-default-title capitalize",
          textColor: "banner-title-default-color",
        }}
        leftClassName="lg:col-7"
        rightClassName="lg:col-5"
        rightContent={
          <Img
            wrapper={{
              className: "bbc-banner-image-bottom-0",
            }}
            src={
              dataJson?.imgBanner
                ? dataJson?.imgBanner
                : "/assets/images/common/banner-merchant-account.png"
            }
            className="h-full w-full "
            width={572}
            height={491}
            priority={true}
            alt={dataJson.alt}
          />
        }
        bgColor={"bg-bbc-country"}
      ></Banner>
      {dataJson.fullWalkthrough &&
        typeof dataJson.fullWalkthrough === "object" &&
        Object.keys(dataJson.fullWalkthrough).length > 0 && (
          <section className="mt-10 lg:mt-20">
            <div className="container">
              <Walkthrough data={dataJson.fullWalkthrough} />
            </div>
          </section>
        )}

      {dataJson.dataHowToOpen &&
        typeof dataJson.dataHowToOpen === "object" &&
        Object.keys(dataJson.dataHowToOpen).length > 0 && (
          <section className="mt-10 lg:mt-20">
            <div className="container">
              <Title
                text={dataHowToOpen.title}
                className="bbc-title mt-20 mb-10 text-center capitalize"
              />
              <div
                className={`paragraph ${
                  country.toLowerCase() === "singapore" && "blue-marker"
                }`}
              >
                {dataHowToOpen.content.map((item, index) => (
                  <div key={index} dangerouslySetInnerHTML={{ __html: item }} />
                ))}
              </div>
              {dataHowToOpen.note ? (
                <div
                  dangerouslySetInnerHTML={{ __html: dataHowToOpen.note }}
                ></div>
              ) : (
                <>
                  <p className=" mt-4 border-l-4 border-bbc-brand-700 pl-2 font-medium">
                    Wonder which can be the best bank for your {country}{" "}
                    company? Let&apos;s find out with our{" "}
                    <LinkRouter
                      href="/guide-and-tool/banking-tool"
                      target="_blank"
                      className="text-bbc-brand-500"
                    >
                      Banking Tool
                    </LinkRouter>
                  </p>
                </>
              )}
            </div>
          </section>
        )}
      {dataJson.dataOnlineBankingTool &&
        typeof dataJson.dataOnlineBankingTool === "object" &&
        Object.keys(dataJson.dataOnlineBankingTool).length > 0 && (
          <section>
            <OnlineBankingTool data={dataJson.dataOnlineBankingTool} />
          </section>
        )}
      {dataOpenBankFee &&
        Object.keys(dataOpenBankFee).length > 0 &&
        dataOpenBankFee.bank_fee.length > 0 && (
          <section className="pb-10 lg:pb-20">
            <OpenBankAccount
              data={dataOpenBankFee}
              country={country}
              title={dataOpenBankFee.title}
            />
          </section>
        )}
      <WhyChooseUs
        title={dataJson?.dataWhyChooseUs?.title}
        note={dataJson?.dataWhyChooseUs?.note}
        sectionClassName="bg-bbc-gradient-3 py-10 lg:py-20"
        data={dataJson?.dataWhyChooseUs?.listIcons}
      />
      <section>
        <HowItWorks data={dataJson?.dataMakeItWork?.contents}>
          <Title className="text-center font-semibold capitalize lg:text-left">
            <span
              className="block text-3xl text-bbc-brand-800 lg:text-bbc-40px"
              dangerouslySetInnerHTML={{
                __html: dataJson?.dataMakeItWork?.title,
              }}
            />
          </Title>
        </HowItWorks>
      </section>
      <section>
        <RequiredDocument
          title={dataJson.dataRequiredDocument.title || "Required Documents"}
          data={dataJson.dataRequiredDocument}
          sectionClassName="py-10 lg:py-20"
          backgroundImage="/assets/images/common/required-documents.png"
        />
      </section>
      <section>
        <div className="container">
          <div className="lg:col-10 lg:m-auto">
            <Faqs
              data={dataJson.dataFaqs}
              title={dataJson.dataFaqs.title}
              description=" "
              defaultActiveKey={dataJson.dataFaqs.defaultActiveKey}
              multipleOpen={dataJson.dataFaqs.multipleOpen}
            />
          </div>
        </div>
      </section>
      <section className="mb-0">
        <div className="container">
          <Title className="title-h2 m-auto mb-10 w-2/3 pb-0 text-center text-bbc-brand-800">
            Industry News & Insights
          </Title>
          <LazyLoad>
            <NewsSlider data={data} />
          </LazyLoad>
        </div>
      </section>
    </>
  );
};

export default MerchantAccountConsultingTemplate;

MerchantAccountConsultingTemplate.propTypes = {
  data: PropTypes.object,
  posts: PropTypes.array,
};

MerchantAccountConsultingTemplate.defaultProps = {
  data: {},
  posts: [],
};
